(function() { window.GUID_ce0f2a9c_7071_42c9_8f7d_a2f2bc23818a = { getGuid: function() { return "ce0f2a9c-7071-42c9-8f7d-a2f2bc23818a"; } }; })();
//alert('test'); 

//# sourceMappingURL=test.js.map
